<template>
  <v-chip class="v-chip--active" color="#F2803F" text-color="#fff">
    <mf-icon color="#fff" fill small>warning</mf-icon>
    <span class="ml-1 font-weight-bold">Em aprovação</span>
  </v-chip>
</template>

<script>
export default {
  name: 'ChipOnApproval',
}
</script>

<style lang="scss" scoped>
::v-deep.theme--light.v-chip--active:before {
  opacity: 0;
}
</style>
